<template>
  <div>
    <navigation />
    <div class="rank-container">
      <table width="100%" class="table">
        <thead>
          <tr>
            <th>排名</th>
            <th>用户</th>
            <th>图片数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, index) of rankList" :key="'rank' + r.userId">
            <td>{{ index + 1 }}</td>
            <td>{{ r.userName }}</td>
            <td>{{ r.imageCount }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';

export default {
  data: function() {
    return {
      rankList: [],
    };
  },
  components: {
    navigation,
  },

  mounted: function() {
    this.getRank();
  },
  methods: {
    getRank() {
      api
        .getRank()
        .then(res => {
          this.rankList = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
p {
  margin: 0px;
}
table {
  border-collapse: collapse;
  margin: 0px;
  text-align: left;
  font-size: 14px;
  margin-top: 18px;
}
table th,
table td {
  padding-left: 24px;
}
table thead tr {
  height: 54px;
  font-weight: 500;
  background: #fafafa;
}
table tr {
  border-bottom: 1px solid #eeeeee;
  height: 54px;
}
table tbody {
  color: #595959;
}
#role-select,
#status-select {
  border: none;
  font-size: 14px;
  font-weight: bold;
  appearance: none;
}
.name-popup {
  position: absolute;
  left: 45%;
  top: 30%;
  height: 180px;
  width: 20%;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 30px;
  box-sizing: border-box;
}
.name-popup > p {
  margin: 20px;
  text-align: center;
}
</style>
